export default __webpack_public_path__ + "static/media/feature-5-trends.6db9dc52.svg";